import { LoadingState, ErrorState, TwoFactorCard, PasswordCard } from '../../components';
import { api, useApi } from '../../api';
import { useT, useRoleLabel } from '../../i18n';
import dict from './Profile.i18n';

/**
 * Admin · Profile — the signed-in person's own account: who they are, two-factor
 * authentication and password. Route /admin/profile, every admin-portal role.
 * System settings (permissions, offices) live under /admin/settings.
 */
export default function AdminProfile() {
  const t = useT(dict);
  const roleLabel = useRoleLabel();
  const meReq = useApi(() => api.auth.me(), []);

  return (
    <div className="cl row full" style={{ minWidth: 0 }}>
      <div className="col grow" style={{ background: 'var(--paper)', overflow: 'auto', minWidth: 0 }}>
        <div
          className="row center between"
          style={{ padding: '14px 24px', borderBottom: '1px solid var(--line)', background: '#fff' }}
        >
          <div className="col">
            <div className="meta">{t('topbar_sub')}</div>
            <div className="h1">{t('heading')}</div>
          </div>
        </div>

        <div className="col gap-16" style={{ padding: '18px 24px', maxWidth: 640 }}>
          {meReq.loading ? (
            <LoadingState label={t('loading')} />
          ) : meReq.error ? (
            <ErrorState message={meReq.error.message} onRetry={meReq.reload} />
          ) : meReq.data ? (
            <>
              <div className="panel" style={{ padding: 16 }}>
                <div className="row gap-12">
                  <div className="col gap-4 grow">
                    <span className="label">{t('email')}</span>
                    <span className="mono" style={{ fontSize: 13 }}>{meReq.data.email}</span>
                  </div>
                  <div className="col gap-4" style={{ width: 180 }}>
                    <span className="label">{t('role')}</span>
                    <span style={{ fontSize: 14 }}>{roleLabel(meReq.data.role)}</span>
                  </div>
                </div>
              </div>
              <TwoFactorCard me={meReq.data} onChanged={meReq.reload} />
              <PasswordCard />
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
